<template>
  <BaseDialog
    :body-loading="!loaded"
    title="提醒"
    width="610px"
    :loading="loading"
    @close="$emit('close')"
  >
    <div style="margin-bottom: 40px;">
      <p v-if="!errors.length">刪除後將無法復原，是否確定刪除？</p>
      <div v-else>
        <p>此班別已有排班紀錄，無法刪除。</p>
        <p>請先刪除從當前時間後所有使用此班別的排班紀錄，之後才能刪除此班別。</p>
        <p v-if="relationAppointmentUnitNames">已排班服務人員：{{ relationAppointmentUnitNames }}</p>
      </div>
    </div>

    <template #btnContainer>
      <div class="flex justify-end items-center">
        <BaseElButton plain @click="$emit('close')">
          取消
        </BaseElButton>
        <BaseElButton
          v-loading="loading"
          :disabled="!!errors.length"
          type="danger"
          @click="onConfirm"
        >
          刪除
        </BaseElButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import { DeleteShiftClassCheck, DeleteShiftsClass } from '@/api/shiftsClass'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'
import notifyMessage from '@/config/notifyMessage'
import { useShop } from '@/use/shop'
import { apiFormatAdaptor } from '@/utils/api'
import { map, flatten, join, get } from 'lodash'

import { computed, defineComponent, onBeforeMount, ref } from 'vue'
export default defineComponent({
  name: 'DeleteShiftClassModal',
  components: { BaseDialog },
  props: {
    selectRow: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, { emit }) {
    const { shopId } = useShop()
    const loading = ref(false)
    const loaded = ref(false)
    const errors = ref([])
    const deleteCheckCourseCategory = async () => {
      loaded.value = false
      const [res, errMsg] = await DeleteShiftClassCheck({
        shopId: shopId.value,
        id: get(props.selectRow, 'id'),
      })
      loaded.value = true
      if (errMsg) {
        window.$message.error(errMsg)
        return
      }

      errors.value = res.errors
    }

    const relationAppointmentUnitNames = computed(() => {
      const appointmentUnitNames = flatten(map(errors.value, 'appointmentUnitNames'))
      return join(appointmentUnitNames, ',')
    })

    const onConfirm = async () => {
      console.log('onConfirm', props.selectRow)
      loading.value = true
      const [, errMsg] = await apiFormatAdaptor(DeleteShiftsClass)({
        shopId: shopId.value,
        id: get(props.selectRow, 'id'),
      })
      loading.value = false
      if (errMsg) {
        window.$message.error(errMsg)
        return
      }
      window.$message.success(notifyMessage.deleteSuccess)
      emit('refresh')
      emit('close')
    }

    onBeforeMount(() => {
      deleteCheckCourseCategory()
    })

    return { errors, onConfirm, loading, loaded, relationAppointmentUnitNames }
  },
})
</script>

<style lang="postcss" scoped>

</style>
